import { inject } from '@angular/core';
import {
  CanActivateChildFn,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';
import { RedirectService } from '../services/redirect-service';

export const authGuard: CanActivateFn = (route, state) => {
  return getProfile(state);
};

export const authGuardChild: CanActivateChildFn = (route, state) => {
  return getProfile(state);
};

async function getProfile(state: RouterStateSnapshot) {
  const _router = inject(Router);
  const local_Service = inject(LocalStorageService);
  const redirectService = inject(RedirectService);
  const token = local_Service.getItem('token');

  if (!token) {
    redirectService.setRedirectUrl(state.url);
    _router.navigateByUrl('/auth');
    return false;
  }

  return true;
}
